<template>
  <div class="subfield" :class="{'subfield-right':!listShow && switchNav}">
    <div class="s-left" v-show="listShow">
      <slot name="list"></slot>
    </div>
    <template v-if="isShowNav">
      <div v-if="listShow" class="shrink" @click="listShowClick" :class="{'shrink-show':!listShow}">
        <img style="width: 10px; height: 28px;" src="@/assets/images/public/public_closeorg.png" alt />
      </div>
      <div v-else class="shrink" @click="listShowClick" :class="{'shrink-show':!listShow}">
        <img style="width: 10px; height: 28px;" src="@/assets/images/public/public_openorg.png" alt />
      </div>
    </template>
    <div class="s-right">
      <slot name="content"></slot>
    </div>
    <div class="s-details" v-show="!listShow && switchNav">
      <slot name="details"></slot>
    </div>
  </div>
</template>
<script>
/**
 * #左右分栏界面
 * 左边显示系统或素材列表
 * 右边显示内容主界面
 * #使用方式
 * import subfield from '@/components/basics/Subfield'
 *  <subfield>
      <template slot="list">$将Trees组件里面的书结构放到此处$</template>
      <template slot="content">$内容主界面$</template> 
    </subfield>
 */
export default {
  name: "Subfield",
  props: {
    isShowNav: {
      type: Boolean,
      default: true
    },
    switchNav: {
      type: Boolean,
      default: false
    },
    listIsShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listShow: true
    };
  },
  methods: {
    listShowClick() {
      this.listShow = !this.listShow;
      this.$emit("listIsShow", this.listShow);
    }
  },
  watch: {
    listIsShow() {
      this.listShow = this.listIsShow;
    }
  }

};
</script>

<style lang="scss" scoped>
.subfield-right {
  width: 100% !important;
  padding: 12px 0px 12px 0 !important;
}
.subfield {
  width: calc(100% - 12px);
  height: calc(100% - 24px);
  // max-height: 683px;
  // 上线适配
  // max-height: 663px;
  padding: 12px 12px 12px 0;
  display: flex;
  .s-left {
    flex: 0 0 18%;
    height: 100%;
    max-width: 280px;
    border-radius: 0 8px 8px 0;
    background-color: #edfbff;
    display: flex;
    flex-direction: column;
    // .trees:nth-last-child(1):first-child {
    // }
    .trees:nth-last-child(2):first-child {
      height: calc(50% - 6px);
    }
    .trees:nth-last-child(2):first-child ~ .trees {
      height: calc(50% - 6px);
    }

    // .trees:nth-last-child(1):first-child {
    //   margin: 0px;
    //   /deep/.el-tree {
    //     // max-height: 640px;
    //     // 上线适配
    //     // max-height: 620px;
    //   }
    // }
    // .trees:nth-last-child(2):first-child {
    //   margin-bottom: 6px;
    //   /deep/.el-tree {
    //     // max-height: 286px;
    //     // 上线适配
    //     max-height: 276px;
    //   }
    // }
    // .trees:nth-last-child(2):first-child ~ .trees {
    //   margin-top: 6px;
    //   /deep/.el-tree {
    //     // max-height: 256px;
    //     // 上线适配
    //     max-height: 246px;
    //   }
    // }
  }
  .s-details {
    flex: 0 0 18%;
    height: 100%;
    max-width: 280px;
    border-radius: 0 8px 8px 0;
    background-color: #edfbff;
    display: flex;
    flex-direction: column;
  }
  .shrink {
    width: 0px;
    height: 100%;
    position: relative;
    img {
      position: absolute;
      top: calc(50% - 26px);
      z-index: 999;
      padding: 12px 12px 12px 0px;
    }
    // padding: 20px;
    // padding-left: 0px;
    // // background-color: #86eae7;
    // border-radius: 0px 4px 4px 0px;
    // font-family: "宋体";
    // line-height: 28px;
    // font-size: 20px;
    // position: absolute;
    // top: calc(50% - 34px);
    // left:191px;
    // cursor: pointer;
  }
  .shrink-show {
    left: 0px;
  }
  .s-right {
    flex: 1;
    overflow: hidden;
    margin-left: 12px;
    border-radius: 8px;
    background: #fff;
  }
}
</style>
